// extracted by mini-css-extract-plugin
module.exports = {"ratingstarfilled":"#f3df76","ratingstarempty":"rgba(255,255,255,.2)"};